import React, {useState, useContext, useRef} from 'react';
import { IonContent, IonText, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonDatetime } from '@ionic/react';
import { IonSlides, IonSlide, IonLabel } from '@ionic/react';

import { EnterPasswordModal } from '../../../zInternal_Features/merchant/components/Modal_EnterPassword';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

export function CreateInventoryRoomModal (props) {

    //alert('inside CreateEmployeeModal');
    //alert(props.openModal);

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [selectedFile, setSelectedFile] = useState(null);

    let [roomID, setRoomID] = useState(null);
    let [roomDateCreated, setRoomDateCreated] = useState(null);
    let [roomPic1, setRoomPic1] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpeg");
    let [roomPic2, setRoomPic2] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpeg");
    let [roomPic3, setRoomPic3] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpeg");
    let [roomPic4, setRoomPic4] = useState("/var/www/web/Public/fileServer/merchants/image-not-available.jpeg");
    let [roomPicsModal, setRoomPicsModal] = useState(false);

    let [showPasswordModal, setShowPasswordModal] = useState(false);

    let createRoomTypeRef = useRef();
    let createRoomDescriptionRef = useRef();
    let createRoomPartNumRef = useRef();
    let createRoomPhoneNumberRef = useRef();
    let createRoomAddressRef = useRef();
    let createRoomCityRef = useRef();
    let createRoomCountryRef = useRef();
    let createRoomCostPerUnitRef = useRef();
    let createRoomSalePriceRef = useRef();
    //let selectedFileRef = useRef();


    function createRoom(adminPassword)
    {
        //let totalRoomPics = [roomPic1, roomPic2, roomPic3, roomPic3];
       // alert("In Crate Room Function");
       // alert(pic1.value);
       // alert(pic2.value);
       // alert(pic3.value);
       // alert(pic4.value);
       //alert(totalRoomPics);

        /*
        let formData = new FormData();
        //formData.append('xRoomPics', totalRoomPics);
        //formData.append('xRoomPics', [roomPic1, roomPic2, roomPic3, roomPic3]);
        formData.append('xPic1', roomPic1);
        formData.append('xPic2', roomPic2);
        formData.append('xPic3', roomPic3);
        formData.append('xPic4', roomPic2);
        formData.append('Tracker', 74300);
        formData.append('user', acctID);
        formData.append('xInventoryRoomType', createRoomTypeRef.current.value);
        formData.append('xInventoryRoomDescription', createRoomDescriptionRef.current.value);
        formData.append('xInventoryRoomPartNum', createRoomPartNumRef.current.value);
        formData.append('xInventoryRoomPhoneNumber', createRoomPhoneNumberRef.current.value);
        formData.append('xInventoryRoomAddress', createRoomAddressRef.current.value);
        formData.append('xInventoryRoomCity', createRoomCityRef.current.value);
        formData.append('xInventoryRoomCountry', createRoomCountryRef.current.value);
        formData.append('xInventoryRoomCostPerUnit', createRoomCostPerUnitRef.current.value);
        formData.append('xInventoryRoomSalePrice', createRoomSalePriceRef.current.value);
        formData.append('xSupportingDocumentation', selectedFile);
        formData.append('xEnterAdminPassword', adminPassword);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        */

        
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74300',
                user: acctID,
                xPic1: roomPic1,
                xPic2: roomPic2,
                xPic3: roomPic3,
                xPic4: roomPic4,
                xInventoryRoomType: createRoomTypeRef.current.value,
                xInventoryRoomDescription: createRoomDescriptionRef.current.value,
                xInventoryRoomPartNum: createRoomPartNumRef.current.value,
                xInventoryRoomPhoneNumber: createRoomPhoneNumberRef.current.value,
                xInventoryRoomAddress: createRoomAddressRef.current.value,
                xInventoryRoomCity: createRoomCityRef.current.value,
                xInventoryRoomCountry: createRoomCountryRef.current.value,
                xInventoryRoomCostPerUnit: createRoomCostPerUnitRef.current.value,
                xInventoryRoomSalePrice:  createRoomSalePriceRef.current.value,
                xSupportingDocumentation: selectedFile,
                xEnterAdminPassword: adminPassword,
                sessionID: sessionID,
            })
        }

        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        props.closeModal(false)
    }


    function saveUploadedFile(event) {
    
        //alert(event);
        
        if(event.target.files === null)
        {
            //selectedFile = "/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg";
            setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg")

        }
        else
        {
            //selectedFileRef.current.value = event.target.files[0];
            setSelectedFile(event.target.files[0]);
        }


    }

    function saveRoomPictures(event) { 

        setRoomPic1(event.target.files[0]);
        setRoomPic2(event.target.files[1]);
        setRoomPic3(event.target.files[2]);
        setRoomPic4(event.target.files[3]);
    
    
    }

    function handleEnterAttachement() {  

        fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setRoomPic1(noImageFile);
            setRoomPic2(noImageFile);
            setRoomPic3(noImageFile);
            setRoomPic4(noImageFile);

            alert("No Room Pics Option checked");

        })
    }

    function onSubmitPasswordHandler(enteredPassword)
    {
        alert('In onSubmitPasswordHandler');

        //setEnteredPassword(event);
        createRoom(enteredPassword);
    }

    function closeModalHandler() {

        props.closeModal(false);
    }
    
    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonSlides pager='true'>
                <IonSlide>
                    <IonItem>
                        <IonLabel for="roomType">Room Type </IonLabel>
                        <select name="roomType" id='roomType' ref={createRoomTypeRef}>
                            <option value='std'>Standard</option>
                            <option value='dlx'>Deluxe</option>
                            <option value='exec'>Executive</option>
                        </select>
                    </IonItem>
                </IonSlide>
                <IonSlide>
                    <IonLabel>Room Description: </IonLabel>
                    <IonInput placeholder='Enter Room Description' ref={createRoomDescriptionRef}></IonInput>
                </IonSlide>
                <IonSlide>
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Room Part Number: </IonLabel>
                                <IonInput placeholder='Enter Room Description' ref={createRoomPartNumRef}></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Room Phone Number: </IonLabel>
                                <IonInput placeholder='Enter Room Phone Number' ref={createRoomPhoneNumberRef }></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Room Address: </IonLabel>
                                <IonInput placeholder='Enter Room Address' ref={createRoomAddressRef}></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Room City: </IonLabel>
                                <IonInput placeholder='Enter Room City' ref={createRoomCityRef}></IonInput>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Room Country: </IonLabel>
                                <IonInput placeholder='Enter Room Country' ref={createRoomCountryRef}></IonInput>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Room Cost Per Unit: </IonLabel>
                                <IonInput placeholder='Enter Room Cost Per Unit' ref={createRoomCostPerUnitRef}></IonInput>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Room Sale Price: </IonLabel>
                                <IonInput placeholder='Enter Room Sale Price' ref={createRoomSalePriceRef}></IonInput>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Upload Room Pics </IonLabel>
                                <form id='fileUploadRoomPics' enctype='multipart/form-data'>
                                    <input type='file' name='fileUploadRoomPics' accept="image/*" onChange={(e) => saveRoomPictures(e)} multiple></input>
                                </form>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonLabel>No Room Pics</IonLabel>
                                <input type='checkbox' id='noAttachment' value='noImage' onClick={(e) => handleEnterAttachement()}></input>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </IonSlide>
                <IonSlide>
                    <IonGrid>
                        <IonRow>
                            <IonCol>
                                <IonLabel>Attachement </IonLabel>
                                <h1>Upload Supporting Documentation</h1>
                                <form id='fileUpload' enctype='multipart/form-data'>
                                    <input type='file' name='imageFile' accept="image/*" onChange={(e) => saveUploadedFile(e)}></input>
                                    <label for='noAttachment'>No Attachment</label>
                                        <input type='checkbox' id='noAttachment' value='noImage' onClick={(e) => saveUploadedFile(e)}></input>
                                </form>
                        </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonButton onClick={() => setShowPasswordModal(true)}> Confirm Room Creation </IonButton>
                            </IonCol>
                        </IonRow>   
                    </IonGrid>                      
                </IonSlide>
            </IonSlides>

            <IonButton onClick={() => closeModalHandler()}>Cancel </IonButton>

            <EnterPasswordModal openModal={ showPasswordModal } closeModal={() => setShowPasswordModal(false)} onSubmitPassword={ onSubmitPasswordHandler }></EnterPasswordModal>

        </IonModal>
        ) : null}
        </React.Fragment>
        )
}